import { handleError } from 'api/utils';
import { createRequest } from 'api/request';

export const getExpiringLink = async (state, id) => {
  return createRequest(`/v1/expiring_link?id=${id}`, state, {
    method: 'GET',
  }).then((res) => handleError(res));
};
